import Permission from '@/mixins/permissions/permission';

export default Permission;
